'use client';

import type { ReactNode } from 'react';
import type { StorageServiceDto } from '@terra/shared-contracts-external-network';
import {
  DrawerGeneralDetails,
  type DrawerDetailRow,
} from '@terra/ui-design-system';

export function buildStorageServiceOverviewContent({
  storage,
  typeBadge,
  seenRows,
  t,
}: {
  storage: StorageServiceDto;
  typeBadge: ReactNode;
  seenRows: DrawerDetailRow[];
  t: (key: string) => string;
}) {
  return (
    <DrawerGeneralDetails
      title={t('generalDetails')}
      rows={[
        [
          { title: t('displayName'), value: storage.name },
          { title: t('type'), value: typeBadge },
        ],
        [
          {
            title: t('hostname'),
            value: storage.endpointHost,
            withTooltip: true,
          },
          { title: t('provider'), value: storage.provider },
        ],
        [
          { title: t('scope'), value: storage.scope },
          ...(storage.cloudProvider
            ? [
                {
                  title: t('cloudProvider'),
                  value: storage.cloudProvider,
                },
              ]
            : []),
        ],
        seenRows,
      ]}
    />
  );
}
